export const BACKGROUND_COLOR = Styles.color.white;
export const USE_BACKGROUND_IMAGE = true;
export const DASHBOARD_PADDING_SIZE = '$4';
export const isModalRewardsDashboard = false;
